(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();){b[a]=b[a]||c}})((function(){try
{console.log();return window.console;}catch(err){return window.console={};}})());

var formatMoney = "$ \{\{amount\}\}";

var isMobile = {
    Android: function() {
        return navigator.userAgent.toLowerCase().match(/android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.toLowerCase().match(/blackberry/i);
    },
    iOS: function() {
        return navigator.userAgent.toLowerCase().match(/iphone|ipad|ipod/i);
    },
    Opera: function() {
        return navigator.userAgent.toLowerCase().match(/opera mini/i);
    },
    Windows: function() {
        return navigator.userAgent.toLowerCase().match(/iemobile/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};

jQuery(function($) {
    if(!isMobile.any()) {
      $('body').addClass('isNotMobile'); 
    }

    $('.content-wrapper').css('padding-top', $('#header').height());
  
    $(document).on("click", ".quantity .minus", function() {
        var wrapper = $(this).parent();
      try {
          wrapper.find('input[type=number]').get(0).stepDown();
        } catch(e) {
          var value = (parseInt(wrapper.find('input[type=number]').val())-1);
          wrapper.find('input[type=number]').val((value>=1 ? value : 1));
        }
    });
    $(document).on("click", ".quantity .plus", function() {
        var wrapper = $(this).parent();
      try {
          wrapper.find('input[type=number]').get(0).stepUp();
        } catch(e) {
          var value = (parseInt(wrapper.find('input[type=number]').val())+1);
          wrapper.find('input[type=number]').val(value);
        }
    });

    if($('#mini-cart').length > 0) {
      initMiniCart();
    }
  
    
      $('body').delegate('.add-to-cart-form', 'submit', function(){
            return validateAddCart($(this));
        });
    
  
    new WOW().init(); 
    
    $(window).scroll(function(){
        if($(this).scrollTop()<=200) {
          $('.scrollup').fadeOut();
        } else {
          $('.scrollup').fadeIn();
        }

        if( $(this).scrollTop()>=100 ) {
            $('#header').addClass('scroll');
        } else {
          $('#header').removeClass('scroll');
        }
      
        if( $(this).scrollTop()>=30 ) {
            $('#top-header').addClass('scroll');
        } else {
          $('#top-header').removeClass('scroll');
        }
    });
  
    $(window).resize(function(){
      $.fancybox.update();
    });

    $("a[rel='fancybox']").fancybox({
      padding: 0,
      margin: [40,30,20,10],
      closeEffect: 'fade',
      autoCenter: true,
      helpers: {
        overlay: { speedOut : 500 }
      }
    });
  
    setupLoginDropdown();
  
      $(document).on('submit', '#newsletter-form', function ( event ) {
        if ( event ) event.preventDefault();
        // validate_input() is a validation function I wrote, you'll have to substitute this with your own.
        if ( validateEmail($(this).find('.email').val()) ) { 
          register($(this)); 
        }else {
          $(this).find('.email').addClass('error');
        }
        return false;
      });
      $(document).on('submit', '.notify-form', function ( event ) {
        if ( event ) event.preventDefault();
        // validate_input() is a validation function I wrote, you'll have to substitute this with your own.
        if ( validateEmail($(this).find('.email').val()) ) { 
          register($(this)); 
        }else {
          $(this).find('.email').addClass('error');
        }
        return false;
      });

    function register($form) {
      $form.find('input[type=submit]').attr('disabled', 'disabled');
      $.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serialize(),
        cache       : false,
//         dataType    : 'json',
//         contentType: "application/json; charset=utf-8",
        error       : function(err) { console.log("Could not connect to the registration server. Please try again later."); },
        success     : function(data) {
          if (data.result != "success") {
            console.log('Something went wrong');
          }
          $('#signup-success p.done').show();
          $('#signup-success p.miss').hide();
          if(data.result=='success' && data.msg.indexOf('Almost finished')>=0) {
      $('#signup-success p.miss').show();
            $('#signup-success p.done').hide();
          }
          $.fancybox({href: '#signup-success', padding: 0, margin: [40,20,40,20]});
          $form.find('input[type=submit]').removeAttr('disabled');
        }
      });
    }
  
});

function validateEmail(email) {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
}

function validateAddCart(form) {
  if(form.find('input[name=id]').val()=='') {
        var allOptionsSelected;
        if(form.find('.single-option-selector').length > 0) {
            allOptionsSelected = true;
            form.find('.single-option-selector').each(function(){
                if($(this).val()=="") {
                    allOptionsSelected = false;
                    return false;
                }
            });
        } else {
            allOptionsSelected = false;
        }
        
        if(allOptionsSelected) {
            var errorMsg = form.find('.validation-msg').text();
            if(errorMsg) {
              alert(errorMsg);
            } else {
              alert("The selected variant is sold out.");
            }
        } else {
          var labels = [];
            form.find('.options label').each(function(key, obj){
                labels.push($(obj).text().replace(':', '').trim());
            });
            alert("You must select a "+labels.join('/')+".");
        }
        return false;
    }
    return true;
}

function initMiniCart() {

    $(document).click(function(){
      $("#mini-cart").slideUp();
    });

    $('body').delegate('#mini-cart a.remove-from-cart', 'click', function(){
      var variantId = $(this).attr('href').replace('#', '');
      
      
        location = '/cart/change/'+variantId+'?quantity=0';
      
      
      return false;
    });
}

/**
 * Page-specific call-backs
 * Called after dom has loaded.
 */
var RADIANCE = {

  common : {
    init: function(){
      $('html').removeClass('no-js').addClass('js');
      setupDropdownMenus();

      $('.nav-arrow', '#top-menu').each( function(){
        $(this).css('top', Math.ceil($(this).parent(2).height()/2) + 1);
      });

    }
  },

  templateIndex : {
    init: function(){

    }
  },

  templateProduct : {
    init: function(){
      //$('#product-actions').bind( 'submit', addToCart );
      $('#thumbs li:nth-child(5n+5)').addClass('last-in-row');
    }
  },

  templateCart : {
    init: function(){
          var checkGiftNote = function() {
              if($('#chk-is-gift').is(':checked')) {
                  $('#is-gift').val('Yes');
                  $('#gift-note').show();
              } else {
                  $('#is-gift').val('No');
                  $('#gift-note').hide();
                  $('#gift-note').find('textarea').val("");
              }
          }
          $('#chk-is-gift').click(function(){
              checkGiftNote();
          });
          checkGiftNote();
    }
  }

}

/**
 * Fire function based upon attributes on the body tag.
 * This is the reason for "template" in layout/theme.liquid
 *
 * @see http://paulirish.com/2009/markup-based-unobtrusive-comprehensive-dom-ready-execution/
 */
var UTIL = {

  fire : function(func,funcname, args){
    var namespace = RADIANCE;
    funcname = (funcname === undefined) ? 'init' : funcname;
    if (func !== '' && namespace[func] && typeof namespace[func][funcname] == 'function'){
      namespace[func][funcname](args);
    }
  },

  loadEvents : function(){
    var bodyId = document.body.id;

    // hit up common first.
    UTIL.fire('common');

    // do all the classes too.
    $.each(document.body.className.split(/\s+/),function(i,classnm){
      UTIL.fire(classnm);
      UTIL.fire(classnm,bodyId);
    });
  }

};
$(document).ready(UTIL.loadEvents);

/**
 * Support for dropdown menus
 */
function setupDropdownMenus(){
  $('#menu-container .has-dropdown').hoverIntent( navRollOver, navRollOut );

  function navRollOver(e){
    $(this).addClass('active').find('ul:first').css('top', $(this).height()).slideDown();
  }
  function navRollOut(e){
    $(this).removeClass('active').find('ul:first').slideUp();
  }
}

function setupLoginDropdown(){
  $('#menu-container .login-link').hoverIntent( loginHover, loginOut );

  function loginHover(e){
    $(this).find('.login-drop-wrap').fadeIn(200);
  }
  function loginOut(e){
    $(this).find('.login-drop-wrap').fadeOut(200);
  }
}

/**
 * Ajaxy add-to-cart
 */
function addToCart(form){
    $('#add-cart-overlay').fadeIn();

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    //async: false,
    data: form.serialize(),
    dataType: 'json',
    error: addToCartFail,
    success: addToCartSuccess,
    cache: false
  });
}

function addToCartSuccess(jqXHR, textStatus, errorThrown){
  updateCartDesc();
    /*$.ajax({
    type: 'GET',
    url: '/cart.js',
    async: false,
    cache: false,
    dataType: 'json',
    success: updateCartDesc
  });*/
  $('#add-cart-overlay').fadeOut();
  
    $.fancybox(
      $("<div />").append($("#item-added").clone().show()).html(), 
          {
              'overlayColor' : '#000',
            "overlayOpacity": 0.5
            }
    );
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  var response = $.parseJSON(jqXHR.responseText);
  $('#add-to-cart-msg').addClass('error').text(response.description).fadeIn('fast');
    $('#add-cart-overlay').fadeOut();
  
    var popup = $("#item-added").clone().addClass('error').show();
    popup.find('.buttons').hide();
    popup.find('.msg').html('- '+ response.description +' -');
    $.fancybox($("<div />").append(popup).html(), {
      'overlayColor' : '#000',
        "overlayOpacity": 0.5
    });
}

function removeItemToCart(variantId){
    $('#add-cart-overlay').fadeIn();

  $('#mini-cart').remove();
    $.ajax({
    type: 'POST',
    url: '/cart/change.js',
        data: {
          id: variantId,
          quantity: 0
        },
    dataType: 'json',
        error: function(){
          updateCartDesc();
            $('#add-cart-overlay').fadeOut();
        },
        success: function(){
            updateCartDesc();
          $('#add-cart-overlay').fadeOut();
        },
    cache: false
  });
}

function updateCartDesc(){  
    $.ajax({
    type: 'GET',
    url: '/pages/mini-cart',
    //async: false,
    cache: false,
        success: function(data){
          $('#mini-cart').remove();
            $('.top-utils .cart').append(data);
        }
  });
}